import { render, staticRenderFns } from "./BrandsAndCharacteristicsPage.vue?vue&type=template&id=08eb852a"
import script from "./BrandsAndCharacteristicsPage.vue?vue&type=script&lang=js"
export * from "./BrandsAndCharacteristicsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports